module.exports = {"items":[{"value":"Drop-In Center","text":"Drop-In Center"},{"value":"Emergency Shelter","text":"Emergency Shelter"},{"value":"Long Term Residential","text":"Long Term Residential"},{"value":"Therapy/Counseling","text":"Therapy/Counseling"},{"value":"Victim Advocacy","text":"Victim Advocacy"},{"value":"Other","text":"Other"}]}


//////////////////
// WEBPACK FOOTER
// ./src/store/data/programTypesLA.json
// module id = 1359
// module chunks = 1